import { Checkbox, FormControl, InputLabel, ListItemText, MenuItem, OutlinedInput, Select, ThemeProvider } from '@mui/material';
import { useState } from 'react';
import { useEffect } from 'react';
import Chart from 'react-apexcharts';
import { useTranslation } from 'react-i18next';

import { SelectComponent } from '../../Components/shared/ReusableSmallComponents';
import SelectPeriod from '../../Components/shared/SelectPeriod';
import { PeriodeEchancier } from '../../data/Interfaces';
import useAxiosPrivate from '../../hooks/useAxiosPrivate';
import useUtilities from '../../hooks/useUtilities';
import useWindowSize from '../../hooks/useWindowSize';
import { FieldComponentFont } from '../../Styles/componentStyles';
import { adapter4BackendProxy } from '../../Utils/utilsDashboards';
import { filtreListPeriodeMonthYear } from './DashbordBackOffice';
import ChiffreAffaire from './Dashbords/ChiffreAffaire';
import MargeBruteMargeNette from './Dashbords/MargeBruteMargeNette';

const EchancierMarges = () => {
    const axiosPrivate = useAxiosPrivate();
    const { i18n } = useTranslation();

    const [selectedStatutPaiementCaffaireCR, setSelectedStatutPaiementCaffaireCR] = useState('all'); // Default selected period
    const [selectedClient, setSelectedClient] = useState([]); // Default selected Client
    const [chartDataCaByCr, setChartDataCaByCr] = useState({
        series: [],

        options: {
            labels: [],
            chart: {
                type: 'bar',
                //stackType: '50%',
                //toolbar: {
                //    show: true
                //},
                zoom: {
                    enabled: true,
                    //type: 'xy', // Use 'xy' for 2D zoom (x and y-axis) or 'y' for only y-axis zoom
                },
            },
            bar : {
                columnWidth: '50px',
            },
            plotOptions: {
                bar: {
                    horizontal: false,
                    //distributed: true, // this line is mandatory
                    columnWidth: '15%', // Set the desired bar width as a percentage of the available space
                }
            },
            dataLabels: {
                enabled: false
            },
            //plotOptions: {
            //    bar: {
            //        horizontal: false,
            //        columnWidth: '10%', // Adjust the width of the bars here
            //        dataLabels: {
            //            enabled: false, // Set this to false to hide data labels
            //        },
            //    },
            //},

            legend: {
                position: 'bottom',
                offsetY: 40
            },
            fill: {
                opacity: 1,
            },
        },
    });
    const ITEM_HEIGHT = 48;
    const ITEM_PADDING_TOP = 8;
    const MenuProps = {
        PaperProps: {
            style: {
                maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
                width: 250,
            },
        },
    };
    const [chiffreAffaire,setChiffreAffaire]=useState();
    const [selectedClientCheckBoxCR, setSelectedClientCheckBoxCR] = useState(['all']);
    const [selectedBackOffice,setSelectedBackOffice]=useState('all');

    useEffect(() =>{
        getDataForCandidatureRecuParAO();
    }, []);
    const { setBackdropOpen} = useUtilities();

    const getDataForCandidatureRecuParAO = async () => {
        try {
            // const response1 = await fetch(API_URI_CVTheque + 'getStatistics/'+ encodeURIComponent(temp), {
            //     method: 'Get',
            // });
            setBackdropOpen(true);
            //const [allCandidatures,totalAos,allStatusCandiatures, allMissions,cras,factures,chiffreAffaire,trafics] = await adapter4BackendProxy(axiosPrivate,  'getStatistics/None');

            const chiffreAffaire=await adapter4BackendProxy(axiosPrivate, 'admin/getCA');

            setChiffreAffaire(chiffreAffaire);
            setBackdropOpen(false);
        } catch (error) {
            console.log(error.response?.status);
        }
    };

    const groupData = (data,filtreItem) => {
        let key2;
        const groupedData = data.reduce((result, item) => {
            const { periode, totalHtClient } = item;
            if (filtreItem === 'backOffice') {
                key2 = item.backOfficeId;
            } else {
                key2 = item.statutPaiementCalculated;
            }

            if (!result[periode]) {
                result[periode] = {};
            }
            if (!result[periode][key2]) {
                result[periode][key2] = 0;
            }
            result[periode][key2] += totalHtClient;
            return result;
        }, {});
        console.log('groupedData',groupedData);
        return groupedData;
    };

    const calculateCAByPeriodeByCr = (data,selectedBO) => {
        var selectBOWithoutLastValue=selectedBO.slice(0, -1);
        const groupedData = groupData(data,'backOffice');
        // Construct the final arrays for each periode
        const periodes = Object.keys(groupedData);
        const backofficeArrays = selectBOWithoutLastValue.map(({ value }) =>
            periodes.map((periode) => groupedData[periode][value]?.toFixed(2) || 0)
        );
        console.log('selectedBackOffice',selectBOWithoutLastValue);
        console.log('periodes',periodes);
        console.log('backofficeArrays',backofficeArrays);
        return {periodes,backofficeArrays,selectBOWithoutLastValue};
    };

    const [selectedBackOfficeValues, setSelectedBackOfficeValues] = useState([]);
    const currentDate = new Date();
    currentDate.setMonth(currentDate.getMonth() - 2);

    const [customDateRange, setCustomDateRange] = useState({
        from: currentDate.toISOString().slice(0, 10), // Get formatted date
        to: new Date().toISOString().slice(0, 10), // Get current date in YYYY-MM-DD format
    });

    const [selectedPeriod, setSelectedPeriod] = useState('custom'); // Default selected period

    const getAllBackOffice = async () => {
        try {
            const listBo=await adapter4BackendProxy(axiosPrivate,  'getAllListBackOffice');
            setSelectedBackOfficeValues(listBo);
        } catch (error) {
            console.log(error.response?.status);
        }
    };

    const statutPaiement = [
        {
            label:'Payé',
            value:'paye',

        },
        {
            label:'Non payé',
            value:'nonPaye'
        },
        {label:'Tout',value:'all'}
    ];

    useEffect(()=>{
        if(Array.isArray(chiffreAffaire) && selectedBackOfficeValues){
            //const firstFiltrePeriode=filtreListPeriode(allStatusMissions,selectedPeriodMission,customDateRangeMission);
            let filteredData;

            filteredData = chiffreAffaire.filter(
                (item) => (item.typeFacture!='factureX' && item.typeFacture!='factureXgroupe' && item.typeFacture!='factureNgroupe')
            );

            if (!selectedClientCheckBoxCR.includes('all')) {
                filteredData = filteredData.filter(
                    (item) => selectedClientCheckBoxCR.includes(item.companyDataId)
                );
            }

            if (selectedStatutPaiementCaffaireCR != 'all') {
                filteredData = filteredData.filter(
                    (item) => item.statutPaimentClient==selectedStatutPaiementCaffaireCR
                );
            }

            if(selectedPeriod)
                filteredData=filtreListPeriodeMonthYear(filteredData,selectedPeriod,customDateRange);

            if (selectedBackOffice != 'all') {
                filteredData = filteredData.filter(
                    (item) => item.backOfficeId == selectedBackOffice
                );
            }

            console.log('second f margeNet Brute',filteredData);
            const {periodes,backofficeArrays,selectBOWithoutLastValue}=calculateCAByPeriodeByCr(filteredData,selectedBackOfficeValues);
            console.log('ListBackOfficeIdsWithoutlALlval',selectBOWithoutLastValue);

            setChartDataCaByCr((prevState) => {
                return {
                    ...prevState,

                    series:selectBOWithoutLastValue.map((office, index) => ({
                        name: office.label,
                        data: backofficeArrays[index],
                    })),
                    options: {
                        ...prevState.options,
                        xaxis: {
                            ...prevState.options.xaxis,
                            categories: periodes
                            //Object.keys(counts)
                            //Array.isArray(CountsListStatusCandidatures) ? CountsListStatusCandidatures.map((item) => item.date) : [],
                        },
                    },
                };
            });
        }
    },[selectedClient,chiffreAffaire,customDateRange,selectedPeriod,selectedBackOfficeValues,selectedStatutPaiementCaffaireCR,selectedClientCheckBoxCR,selectedBackOffice]);

    useEffect(()=>{
        getAllClient();
        getAllBackOffice();
    },[]);

    const { inputSize } = useWindowSize();

    const getAllClient = async () => {
        try {
            // const response2 = await fetch(API_URI_CVTheque + 'getAllListClient', {
            //     method: 'Get',
            // });

            const clientList = await adapter4BackendProxy(axiosPrivate,   'getAllListClient');
            clientList.push({_id: 'all',value:'all', label: 'Tous les clients'});
            console.log(Array.isArray(clientList));
            setSelectedClient(clientList);
        } catch (error) {
            console.log(error.response?.status);
        }
    };
    return (
        <>
            <ChiffreAffaire
                chiffreAffaire={chiffreAffaire}
                selectedClient={selectedClient}
                filtreClient={true}
                width={'100%'}
                height={'365px'}
            />

            <MargeBruteMargeNette
                chiffreAffaire={chiffreAffaire}
                selectedClient={selectedClient}
                filtreClient={true}
                width={'100%'}
                height={'365px'}
            />

            <div
                className='graph1'
                style={{height:'365px',width:'100%'}}
            >
                <h1 className='dashFrame5'>{i18n.t('Chiffre d\'affaire généré par CR')}</h1>
                <div className='filtre1'>
                    <div style={{width:'25%'}}>
                        <ThemeProvider theme={FieldComponentFont}>
                            <FormControl style={{width:'100%'}}>
                                <InputLabel
                                    shrink={true}
                                    id="demo-multiple-checkbox-label"
                                >{i18n.t('Clients')} </InputLabel>
                                <Select
                                    labelId="demo-multiple-checkbox-label"
                                    id="demo-multiple-checkbox"
                                    label={i18n.t('Clients')}
                                    multiple
                                    value={selectedClientCheckBoxCR}
                                    onChange={(event)=>{
                                        const {
                                            target: { value },
                                        } = event;
                                        console.log('typeof value ===',typeof value === 'string' ? value.split(',') : value);
                                        setSelectedClientCheckBoxCR(
                                        // On autofill we get a stringified value.
                                            typeof value === 'string' ? value.split(',') : value,
                                        );
                                        if(value.length>0){
                                            if (value[value.length - 1] == 'all') {
                                                setSelectedClientCheckBoxCR(['all']);
                                            } else {
                                                // If 'all' was selected before, remove it from selectedClientCheckBox
                                                const updatedSelected = value.includes('all')
                                                    ? value.filter((item) => item !== 'all')
                                                    : value;
                                                console.log('updatedSelected',updatedSelected);

                                                setSelectedClientCheckBoxCR(updatedSelected);
                                            }
                                        }
                                    }}
                                    //</FormControl>onChange={(event)=>{
                                    //    const {
                                    //        target: { value },
                                    //    } = event;
                                    //console.log('typeof value ===',typeof value === 'string' ? value.split(',') : value);
                                    //if (value.includes('all')) {
                                    //    setSelectedClientCheckBoxCR(['all']);
                                    //  } else {
                                    //    const updatedSelectedClients = selectedClientCheckBoxCR.includes('all')
                                    //      ? []
                                    //      : [...selectedClientCheckBoxCR];

                                    //    if (updatedSelectedClients.includes(value)) {
                                    //      const index = updatedSelectedClients.indexOf(value);
                                    //      updatedSelectedClients.splice(index, 1);
                                    //    } else {
                                    //      updatedSelectedClients.push(value);
                                    //    }

                                    //    setSelectedClientCheckBoxCR(updatedSelectedClients);
                                    //}

                                    //setSelectedClientCheckBoxCR(
                                    //    typeof value === 'string' ? value.split(',') : value,
                                    //);
                                    //}}
                                    size={inputSize}
                                    sx={{
                                        '& > :not(style)': {borderRadius: '8px' },
                                    }}
                                    style={{ width: '100%', background: 'white' }}
                                    input={<OutlinedInput label="Clients" />}
                                    renderValue={(selected) => {
                                        return selected
                                            .map((id) => {
                                                const selectedOption = selectedClient.find(
                                                    (element) => element._id === id
                                                );
                                                return i18n.t(selectedOption?.label);
                                            })
                                            .join(', ');
                                    }}
                                    MenuProps={MenuProps}
                                >
                                    {Array.isArray(selectedClient) && selectedClient?.map((element) => (
                                        <MenuItem
                                            key={element._id}
                                            value={element._id}
                                        >
                                            <Checkbox checked={selectedClientCheckBoxCR.includes(element._id)} />
                                            <ListItemText primary={i18n.t(element.label)} />
                                        </MenuItem>
                                    ))}

                                </Select>
                            </FormControl>
                        </ThemeProvider>
                    </div>

                    <div style={{width:'25%'}}>
                        <SelectComponent
                            label={i18n.t('Statut paiement/Client')}
                            val={selectedStatutPaiementCaffaireCR}
                            name='Statut paiement/Client'
                            setVal={(e) => {
                                setSelectedStatutPaiementCaffaireCR(e.target.value);
                            }}
                            listVal={statutPaiement}
                        />
                    </div>
                    <div style={{width:'25%'}}>
                        <SelectComponent
                            label={i18n.t('Chargé de recrutement')}
                            val={selectedBackOffice}
                            name='Chargé de recrutement'
                            setVal={(e) => {
                                setSelectedBackOffice(e.target.value);
                            }}
                            listVal={selectedBackOfficeValues}
                        />
                    </div>
                    <div style={{width:'25%'}}>
                        <SelectPeriod
                            selectedPeriod={selectedPeriod}
                            setSelectedPeriod={setSelectedPeriod}
                            setCustomDateRange={setCustomDateRange}
                            listeVal={PeriodeEchancier}
                        />
                    </div>
                </div>
                <div style={{height:'400px'}}>
                    <Chart
                        options={chartDataCaByCr.options}
                        series={chartDataCaByCr.series}
                        type="bar"
                        width={'100%'}
                        height={'85%'}
                    />
                </div>
            </div>

        </>
    );
};
export default EchancierMarges;